module.exports = __webpack_public_path__ + "img/ezhou-airport.bd4c66a.png";